export default function isHeic(fileName) {
  return fileName.toLowerCase().endsWith(".heic");
}
